import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, Grid } from '@mui/material';

import { ChipSelectorControlled } from 'components/_basic/Form/ChipSelector/ChipSelectorControlled';
import { NumberInputControlled } from 'components/_basic/Form/NumberInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { FUNDING_DIRECTIONS_OPTIONS_DEU } from 'components/BusinessToolForm/constants/deu/options_deu';
import { FUNDING_DIRECTIONS_OPTIONS_ES } from 'components/BusinessToolForm/constants/es/options_es';
import { FUNDING_DIRECTIONS_OPTIONS } from 'components/BusinessToolForm/constants/options';
import { FUNDING_DIRECTIONS_OPTIONS_UA } from 'components/BusinessToolForm/constants/ua/options_ua';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';
import {
  FUNDING_NEEDS_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/Overview/FundingNeedsOverview/utils/form';

import { concatWithDot } from 'helpers/string';

export const FundingNeedsOverview: React.FC = () => {
  const { t, i18n } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  const getChosenOptions = (lang: string) => {
    switch (lang) {
      case 'de':
        return FUNDING_DIRECTIONS_OPTIONS_DEU;

      case 'uk':
        return FUNDING_DIRECTIONS_OPTIONS_UA;
      case 'es':
        return FUNDING_DIRECTIONS_OPTIONS_ES;

      default:
        return FUNDING_DIRECTIONS_OPTIONS;
    }
  };

  return (
    <Box>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader locked={!canAccess} title={t('overviewTitle')} badgeText={t('overview.fundingNeeds.title')} />
      </FormSectionCard>

      <FormSectionCard>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            {/* 0.5.1 */}
            <NumberInputControlled
              control={control}
              id="overview.fundingNeeds.totalCost"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TOTAL_COST)}
              label={t('overview.fundingNeeds.totalCost')}
              adornmentType="currency"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.5.2 */}
            <NumberInputControlled
              control={control}
              id="overview.fundingNeeds.fundingAmount"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.FUNDING_AMOUNT)}
              label={t('overview.fundingNeeds.fundingAmount')}
              adornmentType="currency"
              disabled={!canAccess}
            />
          </Grid>
          <Grid item xs={6}>
            {/* 0.5.3 */}
            <NumberInputControlled
              control={control}
              id="overview.fundingNeeds.percentageOfFunding"
              name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING)}
              label={t('overview.fundingNeeds.percentageOfFunding')}
              adornmentType="percentage"
              disabled={!canAccess}
            />
          </Grid>
        </Grid>
      </FormSectionCard>

      {/* 0.5.4 */}
      <FormSectionCard title={t('overview.fundingNeeds.fundingDirections')} disabled={!canAccess}>
        <ChipSelectorControlled
          control={control}
          id="overview.fundingNeeds.fundingDirections"
          options={getChosenOptions(i18n.language)}
          name={concatWithDot(prefix, FUNDING_NEEDS_NAMES.FUNDING_DIRECTIONS)}
          disabled={!canAccess}
          multiple
        />
      </FormSectionCard>
    </Box>
  );
};
